import React, { useContext, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext, AuthProvider } from './AuthContext';
import LoginPage from './LoginPage';
import Dashboard, { PublicFeedbackForm } from './Dashboard';
import PublicCAUpdate from './Components/PublicCAUpdate';
import RegisterPage from './RegisterPage';
import SetupPassword from './SetupPassword';

function ProtectedRoute({ children }) {
  const { user, loading, organization } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-100">
        <p className="text-gray-600">Loading authentication...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!organization || !organization.organizationId) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-100">
        <p className="text-gray-600">Loading organization data...</p>
      </div>
    );
  }

  return children;
}

function AppContent() {
  const { user } = useContext(AuthContext);

  return (
    <Suspense fallback={
      <div className="flex items-center justify-center h-screen bg-gray-100">
        <p className="text-gray-600">Loading...</p>
      </div>
    }>
      <Routes>
        {/* Public routes */}
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/login" element={
          user ? <Navigate to="/" replace /> : <LoginPage />
        } />
        <Route path="/feedback/:formId" element={<PublicFeedbackForm />} />
        <Route path="/ca-update/:token" element={<PublicCAUpdate />} />
        <Route path="/setup-password" element={<SetupPassword />} />

        {/* Protected route */}
        <Route path="/" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
      </Routes>
    </Suspense>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}